import React, { useMemo } from "react";
import styled from "styled-components";
import { useSystemJobsQuery } from "archive/hooks";
import { Row, Col } from "components/bootstrap";
import SystemJob from "components/systemjobs/SystemJob";
const StyledHr = styled.hr`
  margin-bottom: 5px;
  margin-top: 10px;
`;
const ArchiveSystemJobs = () => {
  const { data: jobs, isLoading } = useSystemJobsQuery();
  const groupedJobs = useMemo(() => {
    const restoreSystemJobs = [];
    const createSystemJobs = [];
    const buildCatalogSystemJobs = [];
    Object.values(jobs != null ? jobs : {}).flatMap((nodeJobs) => {
      var _a;
      return (_a = nodeJobs == null ? void 0 : nodeJobs.jobs) != null ? _a : [];
    }).forEach((job) => {
      switch (job.name) {
        case "org.graylog.plugins.archive.job.ArchiveRestoreSystemJob":
          restoreSystemJobs.push(job);
          break;
        case "org.graylog.plugins.archive.job.ArchiveCreateSystemJob":
          createSystemJobs.push(job);
          break;
        case "org.graylog.plugins.archive.job.BuildCatalogSystemJob":
          buildCatalogSystemJobs.push(job);
          break;
        default:
      }
    });
    return [restoreSystemJobs, createSystemJobs, buildCatalogSystemJobs].flat();
  }, [jobs]);
  const systemJobComponents = groupedJobs.map((job) => /* @__PURE__ */ React.createElement(SystemJob, { key: job.id, job }));
  return !isLoading && systemJobComponents.length > 0 && /* @__PURE__ */ React.createElement(Row, { key: "system-job-progress", className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("h2", null, "Job Progress"), /* @__PURE__ */ React.createElement(StyledHr, null), systemJobComponents));
};
export default ArchiveSystemJobs;
